// E7 — модалка «Сессия завершена».
// Показывается когда @dss/auth/SessionExpiredHandler эмитит 'expired' / 'signed_out' /
// 'silent_renew_error'. CTA «Войти» вызывает signinRedirect (через useAuth().login()).
import { useState } from 'react'
import { Button, Modal } from '@dss/design-system'
import { SessionExpiredHandler, useAuth } from '@dss/auth'

export function SessionExpiredModal() {
  const { login } = useAuth()
  const [open, setOpen] = useState(false)
  const [reason, setReason] = useState<'expired' | 'signed_out' | 'silent_renew_error' | null>(
    null,
  )

  const message =
    reason === 'signed_out'
      ? 'Вход был выполнен на другом устройстве, либо администратор завершил вашу сессию.'
      : reason === 'silent_renew_error'
        ? 'Не удалось продлить сессию. Возможно, потеряно соединение с сервером.'
        : 'Срок действия сессии истёк. Войдите заново, чтобы продолжить работу.'

  return (
    <>
      <SessionExpiredHandler
        onSessionRestored={() => { setOpen(false); setReason(null) }}
        onSessionExpired={(r) => {
          setReason(r)
          setOpen(true)
        }}
      />
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Сессия завершена"
        closeOnOverlayClick={false}
        footer={
          <>
            <Button variant="ghost" onClick={() => setOpen(false)}>
              Не сейчас
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setOpen(false)
                void login()
              }}
            >
              Войти
            </Button>
          </>
        }
      >
        <p style={{ margin: 0, fontSize: 14, color: 'var(--color-text-secondary)' }}>{message}</p>
      </Modal>
    </>
  )
}
